// Import Components
import HelloScreen from "../Components/HelloScreen/HelloScreen";
import Stats from "../Components/Stats/Stats";
import Register from "../Components/Register";
import Sponsors from "../Components/Sponsors/Sponsors";
import CountdownTimer from "../Components/CountdownTimer/CountdownTimer";
import Steps from "../Components/Steps/Steps";
import Team from "../Components/Team/Team";
import Balance from "../Components/Balance";
import SocianNetworks from "../Components/SocianNetworks";
import QuestionsAndAnswers from "../Components/QuestionsAndAnswers/QuestionsAndAnswers";
import LinkBlock from "../Components/LinkBlock";
import Header from "../Components/Header/Header";
import Streams from "../Components/Streams/Streams";
import Info from "../Components/Info";
import Feedback from "../Components/Feedback/Feedback";
import StreamsDB from "../Components/Common/StreamsDB";

const Home = () => {
  return(
    <div>

      <div className="Page">
        <Header />
        <HelloScreen />
        {/* <LinkBlock /> */}
        <Stats />
        {/* <Register /> */}
        <CountdownTimer />
        {/* <Balance /> */}
        {/* <Info /> */}
        <QuestionsAndAnswers />
        <Feedback />
        <Steps />
        <Team />
        <Sponsors />
        {/* <SocianNetworks /> */}
        <StreamsDB />
      </div>
    </div>
  );
}
export default Home;
